import * as React from 'react';
import { Ul } from '../list/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var propTypes = {};
var propKeysToRemove = Object.keys(propTypes);
var AnchorBarList = renderWithRef('SubNavList', propTypes, function (props, ref) {
  var classNames = new Set(['swan-anchor-bar-list']);
  var children = props.children;
  var listProps = {
    skin: 'minimal'
  };
  return /*#__PURE__*/React.createElement(RenderComp, {
    root: Ul,
    forwardedRef: ref,
    propKeysToRemove: propKeysToRemove,
    classNames: classNames,
    props: _object_spread({}, props, listProps)
  }, children);
});
export { AnchorBarList };